import request from "@/utils/request";

// 动作库列表
export const getMovementList = (params) => {
  return request.post(`/sport-manage/classDetail/list`, params)
};

// 启动动作库
export const startMovement = (id) => {
  return request.delete(`/sport-manage/classDetail/updEnable/${id}`)
}

// 动作分类
export const getMovementTypeList = () => {
  return request.get(`/sport-manage/category/getList`)
}

// 添加动作
export const addMovement = (params) => {
  return request.post(`/sport-manage/classDetail/add`, params)
}

// 详情
export const getMovementDetail = (id) => {
  return request.get(`/sport-manage/classDetail/detail/${id}`)
}

// 编辑
export const editMovement = (params) => {
  return request.post(`/sport-manage/classDetail/upd`, params)
}

// 删除
export const deleteMovement = (id) => {
  return request.delete(`/sport-manage/classDetail/delete/${id}`)
}